module.exports = __webpack_public_path__ + "img/a243c45.jpg";